import AutocompleteField from "../../../Form/AutocompleteField";
import { LANGUAGES_GOOGLE_OPTIONS } from "../../../../utils/catalogs/languageOptions";

const SelectLanguagesGoogleForm = ({
  name,
  control,
  errors,
  sx = {},
  disabled = false,
  multiple = true,
  options = LANGUAGES_GOOGLE_OPTIONS,
}) => {
  return (
    <AutocompleteField
      name={name}
      control={control}
      errors={errors}
      options={options}
      doTranslate={true}
      fullWidth
      multiple={multiple}
      sx={sx}
      disabled={disabled}
    />
  );
};

export default SelectLanguagesGoogleForm;
